/* eslint-disable */
import { createIcon } from "@chakra-ui/icons"

const BackpackIcon = createIcon({
  displayName: "Backpack",
  viewBox: "0 0 1200 1200",
  path: (
    <g transform="translate(0.000000,1455.000000) scale(0.100000,-0.100000)" fill="#e23e40" stroke="none">
        <path d="M4721 14540 c-897 -56 -1530 -370 -1920 -950 -68 -102 -173 -293
        -200 -362 l-9 -25 101 28 c214 60 502 115 752 144 290 33 488 37 1690 32 1028
        -3 1211 -6 1345 -21 308 -33 587 -82 825 -145 61 -16 112 -27 114 -25 9 8
        -122 254 -188 354 -377 571 -965 883 -1815 960 -163 15 -531 20 -695 10z"/>
        <path d="M3595 12339 c-820 -65 -1541 -349 -2125 -840 -145 -122 -379 -361
        -493 -504 -178 -222 -364 -520 -488 -780 -259 -543 -401 -1089 -470 -1810 -17
        -174 -25 -2957 -9 -3040 32 -161 145 -287 301 -336 59 -19 175 -19 4690 -19
        l4630 0 62 21 c160 53 267 173 296 333 14 77 15 2584 1 2841 -38 697 -199
        1323 -490 1905 -217 434 -469 780 -806 1110 -469 459 -1020 780 -1657 964
        -224 65 -442 107 -762 148 -110 14 -2513 20 -2680 7z m1533 -1239 c211 -19
        391 -69 572 -160 571 -286 913 -861 887 -1490 -17 -410 -174 -767 -467 -1061
        -233 -234 -482 -370 -810 -441 -90 -19 -134 -22 -315 -22 -179 0 -225 3 -311
        22 -150 32 -245 66 -389 136 -266 130 -476 318 -639 569 -188 288 -278 649
        -247 984 21 230 64 382 166 588 150 303 407 560 710 710 196 97 365 146 569
        164 131 12 149 12 274 1z"/>
        <path d="M341 3954 c-175 -47 -301 -182 -331 -355 -8 -45 -10 -471 -8 -1454
        l3 -1390 23 -80 c95 -339 331 -560 692 -653 60 -15 391 -16 4200 -20 2878 -2
        4169 0 4248 8 395 37 700 289 804 665 l23 80 3 1395 c2 1021 0 1411 -8 1455
        -34 174 -174 318 -348 354 -38 8 -1319 11 -4650 10 -3981 0 -4604 -2 -4651
        -15z"/>
    </g>
  )
})

export default BackpackIcon
